import axios from 'axios';

interface UserPermissions {
    permissions: string[];
    entities: Entity[];
    impersonate: null|string|undefined;
    currentCustomer: App.Domains.Auth.Dto.Customer | null;
    impersonateFirstName: null|string|undefined;
}

export interface Entity {
    id: string;
    name: string;
}

const GET_PERMISSIONS = 'permission/user';

export const fetchUserPermissions = async (jwt: string) => {
    const {data: permissions} = await axios.get<UserPermissions>('/api/' + GET_PERMISSIONS, {
        headers: {Authorization: `Bearer ${jwt}`},
    });

    return permissions;
};

export const checkIfAuthorized = (userPermissions: string[], requiredPermissions: string[]) => {
    return requiredPermissions.every((permission) => userPermissions.includes(permission));
};
